module.exports = __webpack_public_path__ + "img/player-filled.54392649.svg";